var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpModelActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.31,960H75.59a8,8,0,0,1-7.5-10.8l57-153.2a63.28,63.28,0,0,1,5.66-8,348.77,348.77,0,0,0,13.81,62.88A303,303,0,0,0,158,884.33a761.47,761.47,0,0,0,38.51,71.82A8,8,0,0,0,203.31,960Z",
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.76,682.9c-.94-.26-1.89-.54-2.83-.82h0C442.87,682.36,443.82,682.63,444.76,682.9Z",
    style: {
      fill: "#5b6673"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.25,688.32c-1.45.16-2.9.28-4.35.37C499.35,688.59,500.8,688.47,502.25,688.32Z",
    style: {
      fill: "#5b6673"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.76,687.79c-1.47.21-2.94.38-4.41.52C503.82,688.16,505.29,688,506.76,687.79Z",
    style: {
      fill: "#5b6673"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.47,848.38c-4.79-10.24-18.48-57.86-28.37-64.08a63.53,63.53,0,0,0-34.6-18.5L671.39,732.32c-27.68-33.35-45.06-75-47.6-118.37a172.14,172.14,0,0,0,23.49-54.75c1.09-2.31,16.66-166.51,17.2-168.9-88.14-16.66-163-73.55-200.21-155.5-110.75,16.39-178.87,117.94-168,210.5,26.66,93.78,34.27,204.05,145.66,236.77h0c20.91,6.24,43.15,8.58,64.83,5.71,5.86,73.4-37.48,115.16-74.64,162.65-22.54,32.3,8,60.25,35.88,96.26,4.45,4.9.58,13.43-6.1,13.2H411.5v.1H203.31a8,8,0,0,1-6.85-3.85A761.47,761.47,0,0,1,158,884.33C136.73,838.82,128.47,793.25,128,744a351.41,351.41,0,0,1,19.33-115.32C207,456.4,205.22,428.69,201.28,368,182.14,207.63,266.44,69.63,432,72c17.9,0,58.59,2.4,88.8,22.2,140.15-11,234.07,80.26,241.7,245.09C750.78,559,995.06,636.4,918.47,848.38Z",
    style: {
      fill: "#006eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.93,682.07h0c.94.28,1.89.56,2.83.82C443.82,682.63,442.87,682.36,441.93,682.07Zm56,6.62c1.45-.09,2.9-.21,4.35-.37C500.8,688.47,499.35,688.59,497.9,688.69Zm4.45-.38c1.47-.14,2.94-.31,4.41-.52C505.29,688,503.82,688.16,502.35,688.31Z",
    style: {
      fill: "#96a2b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.51,952a8,8,0,0,1-8,8h-537v-.1h50.4c6.67.2,10.56-8.26,6.1-13.2-29.55-37.64-60.22-66.42-33.2-100.28,37.07-44.47,77.63-88.54,72-158.63-37.69,4.79-76.57-5.13-108.19-26.09-69.25-37.58-82.57-149-102.3-216.4-10.53-92.9,56.61-193.68,168-210.5,37.2,82,112.08,138.84,200.21,155.5-.59,2.9-16.08,166.22-17.2,168.9A172.14,172.14,0,0,1,623.79,614c2.54,43.39,19.92,85,47.6,118.37,6.88,2.11,197.27,33.9,197.91,37.61a63.76,63.76,0,0,1,29.6,25.87C911.42,830.67,944.59,916,956.51,952Z",
    style: {
      fill: "#a3d7ff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpModelActive);
export default __webpack_public_path__ + "static/media/hp_model_active.c7cd7d30a3f0daf6c11405a601e5c850.svg";
export { ForwardRef as ReactComponent };